import { render, staticRenderFns } from "./Sesiones.vue?vue&type=template&id=4657c528&scoped=true&"
import script from "./Sesiones.vue?vue&type=script&lang=js&"
export * from "./Sesiones.vue?vue&type=script&lang=js&"
import style0 from "./Sesiones.vue?vue&type=style&index=0&id=4657c528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657c528",
  null
  
)

export default component.exports